/**
 * Player settings for the prototype. Moves into the versioned save document (src/meta) in Phase 3.
 */

export type ControlScheme = 'swipe' | 'tap';

/**
 * Swipe is the default (playtest decision); tap left/right is an accessibility option in Settings.
 * `?controls=` in the URL overrides the saved choice (testing).
 */
export function loadControlScheme(saved: ControlScheme = 'swipe'): ControlScheme {
  const fromUrl = new URLSearchParams(window.location.search).get('controls');
  return fromUrl === 'tap' || fromUrl === 'swipe' ? fromUrl : saved;
}
